import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { conditionalParam } from '../../AGraphUtils';
import { awBridgeApi } from '../../Base';
import { AWProposalV2, BulkGetRequest, ProposalWithEntryAndAnalysis } from '../../Models';
import { CreateProposalsRequestV2, ProposalV2Request, ProposalWithEntry, UpdateProposalsRequestV2 } from './Models';

/**
 * Update an existing proposal and its entry, put them back into ADL.
 * @param params
 */
export function putUpdateProposalsV2(
  params: UpdateProposalsRequestV2,
  pkg: string
): Promise<AxiosResponse<ProposalWithEntry[]>> {
  const path = '/v2/proposals';
  return awBridgeApi.put<ProposalWithEntry[]>(path, params, { params: { pkg } });
}

/**
 * Create a proposal and its entry, persist them in ADL.
 * @param params
 */
export function postCreateProposalsV2(
  params: CreateProposalsRequestV2,
  pkg: string
): Promise<AxiosResponse<ProposalWithEntry[]>> {
  const path = '/v2/proposals';
  return awBridgeApi.post<ProposalWithEntry[]>(path, params, { params: { pkg } });
}

/**
 * Replace POST "/v1/proposals/bulkGetWithEntryAndAnalysis"
 *
 * Get back a proposal with optional entry and analysis,
 * If including analysis but the proposal analysis doesn't exist, then just set analysis to null,
 * in which case Front-end needs to gracefully handle this by calling AWPA to re-analyze.
 * @param params
 */
export function getProposalV2(params: ProposalV2Request): Promise<AxiosResponse<ProposalWithEntryAndAnalysis>> {
  const { proposalId, includeAnalysis = false, pkg } = params;
  const path = `/v2/proposals/${proposalId}`;
  const config: AxiosRequestConfig = {
    params: { includeAnalysis, pkg },
  };
  return awBridgeApi.get(path, config);
}

/**
 * Get back multiple proposals in bulk.
 * @param params
 * @param allowMissing whether to allow any missing proposals to succeed the request.
 */
export function postBulkGetProposalsV2(
  params: BulkGetRequest,
  pkg: string,
  allowMissing: boolean = false
): Promise<AxiosResponse<AWProposalV2[]>> {
  const path = `/v2/proposals/bulkGet`;
  const config: AxiosRequestConfig = {
    params: { pkg: conditionalParam(path, 'pkg', pkg), allowMissing },
  };
  return awBridgeApi.post(path, params, config);
}
